/**
 * Stores the default color palette for the color picker. Default color palette directly from Trimble Connect.
 *
 * If you use VS Code based code editors, I highly recommend this extension:
 * Name: Color Highlight
 * Description: Highlight web colors in your editor
 * VS Marketplace Link: https://marketplace.cursorapi.com/items/?itemName=naumovs.color-highlight
 *
 * The color arrays are stored in rows (first row, second row, etc.)
 * Use the color picker component to see exactly which color you need to change if so
 */

const row1: string[] = [
  '#ad1457',
  '#f4511e',
  '#fffd38',
  '#0a8043',
  '#3f51b5',
  '#1b1a27',
];
const row2: string[] = [
  '#ec00b6',
  '#ef6c00',
  '#e4c442',
  '#019688',
  '#7886cb',
  '#6a6977',
];
const row3: string[] = [
  '#d50002',
  '#fd8b25',
  '#c0ca33',
  '#50d0cb',
  '#b39ddb',
  '#aeaeb7',
];
const row4: string[] = [
  '#fc0d1b',
  '#f09300',
  '#7cb342',
  '#029be5',
  '#dca1dc',
  '#d0d0d7',
];
const row5: string[] = [
  '#e67c73',
  '#f7bf25',
  '#3ccb3e',
  '#446dde',
  '#b85ad0',
  '#f3f3f7',
];

/**
 * Array of color rows. First dimension is row, second dimension are the colors in that row.
 */
export const defaultColorsByRow: string[][] = [row1, row2, row3, row4, row5];

/**
 * All rows condensed into a single dimensional array, row-first
 * @example [row1[0], row1[1], ..., rowN(x)]
 */
export const defaultColorsFlat: string[] = defaultColorsByRow.flat();
